import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Select from "react-select";

const EditModal = ({
  open,
  setOpen,
  setCompany,
  setVatNumber,
  setPhone,
  setWebsite,
  setAddress,
  setCity,
  setState,
  setZipCode,
  setCountry,
  setSelectedGroups,
  setCurrency,
  setLanguage,
  selectedClient,
  fetchDetail,
  setSelectedClient,
  company,
  vatNumber,
  phone,
  website,
  groups,
  currency,
  language,
  setName,
  setEmail,
  address,
  country,
  state,
  city,
  zipCode,
  name,
  selectedGroups,
  email,
  defaultLanguages,
  setClientGroup,
  updateData,
  loading,
}) => {
  const onCloseModal = () => setOpen(false);
  console.log(selectedClient);
  useEffect(() => {
    if (selectedClient && selectedClient.clientDetails) {
      console.log(selectedClient);
      setCompany(selectedClient.clientDetails.company);
      setVatNumber(selectedClient.clientDetails.vat_number);
      setPhone(selectedClient.mobile);
      setWebsite(selectedClient.clientDetails.website);
      setAddress(selectedClient.clientDetails.address);
      setCity(selectedClient.clientDetails.city);
      setState(selectedClient.clientDetails.state);
      setZipCode(selectedClient.clientDetails.zip_code);
      setCountry(selectedClient.clientDetails.country);
      setClientGroup(selectedClient.clientDetails.groups);
      setName(selectedClient?.name);
      setEmail(selectedClient?.email);
      setSelectedGroups(selectedClient?.clientDetails?.groups);
      setCurrency(selectedClient?.clientDetails?.currency);
      setLanguage(selectedClient?.clientDetails?.default_language);
    }
  }, [selectedClient]);
  return (
    <div>
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          modal:
            "max-h-[90vh] overflow-y-auto p-4 w-[90%] max-w-[600px] custom-scrollbar",
        }}
      >
        <h1 className="mt-[6px] mb-[20px] font-medium text-[18px]">
          Edit Client
        </h1>
        {/* <!-- Form starts --> */}
        <form onSubmit={updateData}>
          <div className="gap-6 grid grid-cols-1">
            {/* <!-- Company --> */}
            <div>
              <label
                for="name"
                className="block font-medium text-gray-700 text-sm"
              >
                Name *
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                id="company"
                className="block border-gray-300 shadow-smsm:text-sm mt-1 p-2 border rounded-md w-full focus-visible:outline-none"
                name="name"
                required
              />
            </div>
            <div>
              <label
                for="name"
                className="block font-medium text-gray-700 text-sm"
              >
                Email *
              </label>
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                id="company"
                className="block border-gray-300 shadow-smsm:text-sm mt-1 p-2 border rounded-md w-full focus-visible:outline-none"
                name="name"
                required
              />
            </div>

            {/* <!-- Company --> */}
            <div>
              <label
                for="company"
                className="block font-medium text-gray-700 text-sm"
              >
                Company *
              </label>
              <input
                type="text"
                id="company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="company"
                required
              />
            </div>

            {/* <!-- VAT Number --> */}
            <div>
              <label
                for="vat"
                className="block font-medium text-gray-700 text-sm"
              >
                VAT Number
              </label>
              <input
                type="text"
                id="vat"
                value={vatNumber}
                onChange={(e) => setVatNumber(e.target.value)}
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="vat"
                required
              />
            </div>

            {/* <!-- Phone --> */}
            <div>
              <label
                for="phone"
                className="block font-medium text-gray-700 text-sm"
              >
                Phone
              </label>
              <input
                type="tel"
                id="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="block border-gray-300 shadow-smsm:text-sm mt-1 p-2 border rounded-md w-full focus-visible:outline-none"
                name="phone"
                required
              />
            </div>

            {/* <!-- Website --> */}
            <div>
              <label
                for="website"
                className="block font-medium text-gray-700 text-sm"
              >
                Website
              </label>
              <input
                type="url"
                id="website"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="website"
                required
              />
            </div>

            {/* <!-- Groups --> */}

            <div className="relative p-[0] w-[full]">
              <label
                for="groups"
                className="block mb-[7px] font-medium text-gray-700 text-sm"
              >
                Groups
              </label>
              <Select
                className="w-full h-[40px]"
                closeMenuOnSelect={false}
                isMulti
                defaultValue={selectedClient?.clientDetails?.groups.map(
                  (g) => ({
                    value: g,
                    label: g,
                  })
                )}
                onChange={(o) => {
                  const arr = o.map((op) => op.value);
                  setSelectedGroups(arr);
                }}
                options={groups.map((g) => {
                  return { value: g, label: g };
                })}
              />
            </div>

            {/* <!-- Currency and Default Language in one row --> */}
            <div className="flex md:flex-row flex-col justify-between items-center gap-[8px] w-full">
              {/* <!-- Currency --> */}

              <div className="inline-block relative w-[100%] md:w-[50%] text-left">
                <label
                  htmlFor="currency"
                  className="block font-medium text-gray-700 text-sm"
                >
                  Currency
                </label>
                <Select
                  className="w-full h-[40px]"
                  name="currency"
                  closeMenuOnSelect={false}
                  isMulti
                  defaultValue={selectedClient?.clientDetails?.currency.map(
                    (c) => ({
                      value: c,
                      label: c,
                    })
                  )}
                  onChange={(o) => {
                    const arr = o.map((op) => op.value);
                    setCurrency(arr);
                  }}
                  options={[
                    { label: "USD", value: "$" },
                    { label: "INR", value: "₹" },
                  ]}
                  required
                />
              </div>

              {/* <!-- Default Language --> */}
              <div className="mt-[22px] md:mt-[0] ml-0 w-[100%] md:w-[50%]">
                <label
                  for="language"
                  className="block font-medium text-gray-700 text-sm"
                >
                  Default Language
                </label>
                <Select
                  className="w-full h-[40px]"
                  name="language"
                  closeMenuOnSelect={false}
                  isMulti
                  defaultValue={selectedClient?.clientDetails?.default_language.map(
                    (l) => ({
                      value: l,
                      label: l,
                    })
                  )}
                  onChange={(o) => {
                    const arr = o.map((op) => op.value);
                    setLanguage(arr);
                  }}
                  options={defaultLanguages.map((op) => {
                    return { label: op, value: op };
                  })}
                  required
                />
              </div>
            </div>

            {/* <!-- Address --> */}
            <div>
              <label
                for="address"
                className="block font-medium text-gray-700 text-sm"
              >
                Address
              </label>
              <input
                type="text"
                id="address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="address"
                required
              />
            </div>

            {/* <!-- City --> */}
            <div>
              <label
                for="city"
                className="block font-medium text-gray-700 text-sm"
              >
                City
              </label>
              <input
                type="text"
                id="city"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="city"
                required
              />
            </div>

            {/* <!-- State --> */}
            <div>
              <label
                for="state"
                className="block font-medium text-gray-700 text-sm"
              >
                State
              </label>
              <input
                type="text"
                id="state"
                value={state}
                onChange={(e) => setState(e.target.value)}
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="state"
                required
              />
            </div>

            {/* <!-- Zip Code --> */}
            <div>
              <label
                for="zip"
                className="block font-medium text-gray-700 text-sm"
              >
                Zip Code
              </label>
              <input
                type="text"
                id="zip"
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm"
                name="zip"
                required
              />
            </div>

            {/* <!-- Country --> */}
            <div>
              <label
                for="country"
                className="block font-medium text-gray-700 text-sm"
              >
                Country
              </label>
              <input
                type="text"
                id="country"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="country"
                required
              />
            </div>
          </div>

          {/* <!-- Submit Button --> */}
          <div className="flex justify-end gap-[10px] mt-6 p-2 w-full">
            <button
              onClick={() => setOpen(false)}
              type="button"
              className="border-[#27004a] bg-white border rounded-md w-20 h-10 text-[#27004a]"
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`allcrm-btn1 ${loading ? "opacity-40" : ""}`}
            >
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
        {/* <!-- Form ends --> */}
      </Modal>
    </div>
  );
};

export default EditModal;
